<template>
  <Icon>
    <svg slot="svg" width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
      <title>{{ title }}</title>
      <defs>
        <path d="M9,22.00189 C8.44771,22.00189 8,21.55419 8,21.00189 L7.99999,18.00189 L4,18.00189 C2.89543,18.00189 2,17.10649 2,16.00189 L2.0094,3.99999 C2.0094,2.89499 2.89538,2 3.99939,2 L19.99939,2 C21.10339,2 21.99939,2.89499 21.99939,3.99999 L21.99939,15.99999 C21.99939,17.10399 21.10339,17.99999 19.99939,17.99999 L13.90399,18.00159 L10.19789,21.70769 C10.00529,21.90029 9.75366,21.99789 9.50122,22.00049 L9.49998,22.00189 L8.99999,22.00189 L9,22.00189 Z" id="path-1-severity"></path>
      </defs>
      <g id="icons/severity/error" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <rect id="Bounding-Box" x="0" y="0" width="24" height="24"></rect>
        <mask id="mask-2-severity" fill="white">
          <use xlink:href="#path-1-severity"></use>
        </mask>
        <use id="Shape" :fill="fill" fill-rule="nonzero" xlink:href="#path-1-severity"></use>
        <path d="M11.9999998,14.6060787 C12.5522844,14.6060787 12.9999995,14.1583635 12.9999995,13.6060789 C12.9999995,13.0537943 12.5522844,12.6060791 11.9999998,12.6060791 C11.4477151,12.6060791 11,13.0537943 11,13.6060789 C11,14.1583635 11.4477151,14.6060787 11.9999998,14.6060787 Z M11,6.0000018 C11,5.44771605 11.447716,5 12.0000018,5 C12.5522875,5 13.0000035,5.44771605 13.0000035,6.0000018 L13.0000035,10.0000054 C13.0000035,10.5522911 12.5522875,11.0000072 12.0000018,11.0000072 C11.447716,11.0000072 11,10.5522911 11,10.0000054 L11,6.0000018 Z" id="Combined-Shape" fill="#FFFFFF" fill-rule="nonzero" mask="url(#mask-2-severity)"></path>
      </g>
    </svg>
  </Icon>
</template>

<script>
import Icon from "./icon";

export default {
  name: "DsInfoIcon",
  components: {
    Icon
  },
  props: {
    warning: {
      type: Boolean,
      default: false
    },
    transaction: {
      type: Boolean,
      default: false
    },
    notice: {
      type: Boolean,
      default: false
    },
    info: {
      type: Boolean,
      default: false
    },
    error: {
      type: Boolean,
      default: false
    },
    emergency: {
      type: Boolean,
      default: false
    },
    debug: {
      type: Boolean,
      default: false
    },
    critical: {
      type: Boolean,
      default: false
    },
    alert: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    fill() {
      if (this.warning) return '#bd10e0';
      else if (this.transaction) return '#8d99ae';
      else if (this.notice) return '#002c73';
      else if (this.info) return '#1da1f2';
      else if (this.error) return '#5000a8';
      else if (this.emergency) return '#ff5d00';
      else if (this.debug) return '#7ed321';
      else if (this.critical) return '#7a0000';
      else return '#d61600';
    },
    title() {
      if (this.warning)
        return "Warning";
      else if (this.transaction)
        return "Transaction";
      else if (this.notice)
        return "Notice";
      else if (this.info)
        return "Info";
      else if (this.error)
        return "Error";
      else if (this.emergency)
        return "Emergency";
      else if (this.debug)
        return "Debug";
      else if (this.critical)
        return "Critical";
      else return "Alert";
    }
  }

};
</script>


// WEBPACK FOOTER //
// ../panel-theme/src/js/icons/ds-info-icon.vue